export const ReuseDataOptions = Object.freeze({
  NONE: "None",
  REUSE_DATA_ONLY_IN_TEMPLATE: "Reuse data in template only",
  REUSE_DATA_AND_VALIDATION_STATUS: "Reuse data and validation status",
  REUSE_DATA_AND_REVALIDATE_ALL_DATA: "Reuse data and revalidate all data"
});